import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ChevronRight = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m10 6.708 6 6-6 6'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M9.47 6.178a.75.75 0 0 1 1.004-.052l.056.052 6 6 .094.114a.75.75 0 0 1 0 .832l-.094.114-6 6a.75.75 0 1 1-1.06-1.06l5.47-5.47-5.47-5.47-.052-.056a.75.75 0 0 1 .052-1.004'
        fill='currentColor'
      />
    )}
  </IconBase>
);
